var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"icp",on:{"click":_vm.jump}},[_vm._v("闽ICP备2022010578号-1")]),_vm._v("© 2022 Followind Studio All Right Seserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }